<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import ListingsTable from './ListingsTable';

export default {
  page: {
    title: 'Listings',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, ListingsTable },
  data() {
    return {
      title: 'Listings',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Listings', active: true, },
      ],
      
      loading: true,
      filters: {
        whereins: {
          website: [],
        },
      }
    }
  },
  watch: {

  },
  created() {
    this.filters.whereins.website = [this.website_id];
  },
  methods: {
    
  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <ListingsTable ref="ListingsTable" :changefilters="filters" @loadchange="(e) => {loading = e;}"></ListingsTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
